import {Injectable} from '@angular/core';
import {LineChartDataParams, UpdateLineChartParams} from "../types/line-chart-modal.types";
import {defaultLineChartQueryParams} from "../configs/line-chart-modal-config";

@Injectable({
  providedIn: 'root'
})
export class LineChartWeekService {
  public setLineChartDataParams(updateLineChartParams: UpdateLineChartParams, parentUrl: string): LineChartDataParams {
    const queryParams = {
      ...defaultLineChartQueryParams,
      sort: [
        'dateFrom,asc'
      ],
      productId: updateLineChartParams.selectedProductId,
      dateFromFrom: updateLineChartParams.rangeData.dateFrom,
      dateFromTo: updateLineChartParams.rangeData.dateTo
    };

    return {
      path: parentUrl,
      queryParams: queryParams
    };
  }
}
